import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/models/api-response';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { createFilterParams } from 'src/app/shared/functions/create-filter-params';
import { environment } from 'src/environments/environment';
import {
  IDeliveryConditionRequest,
  IDeliveryConditionResponse,
} from '../models/delivery-condition.model';

const headers = { 'content-type': 'application/json' };

@Injectable({
  providedIn: 'root',
})
export class DeliveryConditionApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}/DeliveryCondition`;
  }

  constructor(private http: HttpClient) {}

  loadDeliveryConditions(
    currentFilter?: MainTableFilterModel
  ): Observable<ApiResponse<IDeliveryConditionResponse[]>> {
    const params = createFilterParams(currentFilter);

    return this.http.get<ApiResponse<IDeliveryConditionResponse[]>>(this.url, { params });
  }

  loadAllDeliveryConditions(departmentId?: string): Observable<IDeliveryConditionResponse[]> {
    let url = `${this.url}/List`;
    if (departmentId) {
      url = `${url}?DepartmentId=${departmentId}`;
    }
    return this.http.get<IDeliveryConditionResponse[]>(url);
  }

  loadDeliveryConditionById(id: string): Observable<IDeliveryConditionResponse> {
    const url = `${this.url}/${id}`;
    return this.http.get<IDeliveryConditionResponse>(url);
  }

  createDeliveryCondition(
    deliveryCondition: IDeliveryConditionRequest
  ): Observable<IDeliveryConditionResponse> {
    return this.http.post<IDeliveryConditionResponse>(this.url, deliveryCondition, { headers });
  }

  updateDeliveryCondition(
    deliveryCondition: IDeliveryConditionRequest
  ): Observable<IDeliveryConditionResponse> {
    const url = `${this.url}/${deliveryCondition.id}`;
    return this.http.put<IDeliveryConditionResponse>(url, deliveryCondition, { headers });
  }

  deleteDeliveryCondition(id: string): Observable<void> {
    const url = `${this.url}/${id}`;
    return this.http.delete<void>(url);
  }
}
